/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { of } from 'rxjs';
import { MyInjector } from '@src/app/app.module';
import { TenantId } from '@src/app/model/abstract-object';
import { Unit } from '@src/app/model/unit';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { RequestContextService } from '@src/app/modules/crm/request-context.service';

export class NewUnitRequestAction implements IFormAction {
    name = $localize`Create Request`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'add_circle';
    approvalNeeded = false;
    disabled = false;
    approvalText = "";
    tipText = $localize `Create a new service request related to this unit`;
    teamId: TenantId;

    unit: Unit;


    /** A case rather than a work order - there is no supplier in sight from a unit, and the
     *  stepper lets them switch if it turns out there should be. */
    action(unit: Unit) {
        MyInjector.instance.get(RequestContextService)
            .newRequest({ requestType: 'case', teamId: this.teamId, unit, person: unit.owner })
            .subscribe();
        return of(this.unit);
    }
    //  setup(serviceRequest: ServiceRequest) {
    setup(unit: Unit) {
        const reqContextSvc = MyInjector.instance.get(RequestContextService);
        if (unit?.teamId && reqContextSvc.canCreate()) {
            this.teamId = unit.teamId;
            this.show = true;
        } else {
            this.show = false;
        }
        this.unit = unit;
    }
}
